import { InvoiceDetail } from '@/api/useFreight/types'
import { TransactionDetail } from '../columnDefs'

export const FLIFormTypes = { accessorial: 'accessorial', baseFreight: 'base freight' } as const
export type FLIFormType = (typeof FLIFormTypes)[keyof typeof FLIFormTypes]

export const FormActionTypes = { create: 'create', edit: 'edit' } as const
export type FormActionType = (typeof FormActionTypes)[keyof typeof FormActionTypes]

export type BaseFreightFormType = {
  base_freight_subtype: string | null
  product: { label: string; value: string } | null
  origin: { label: string; value: string } | null
  destination: { label: string; value: string } | null
  bol_number: string | null
  uom: string | null
  amount: number | null
  rate: number | null
}

export type AccessorialFormType = {
  accessorial_id: string | null
  rate: number | null
  amount?: number | null
  total?: number | null
  reason_code?: string | null
  origin: { label: string; value: string } | null
  destination: { label: string; value: string } | null
}

export type AccessorialOptionType = {
  label: string
  value: string
  description: string
  feeType: string
  rate: number
  disabled: boolean
  requiresReasonCode: boolean
}

export interface AccessorialContext {
  counterpartyId?: string
  bookType?: 'Cost' | 'Revenue'
  rebillUpdateActions?: {
    addRebillLineItem?: (detail: Omit<InvoiceDetail, 'id'>, orderId: string) => void
    overrideRebillLineItem?: (
      detail: InvoiceDetail,
      productGroupOverride: string | null | undefined,
      finalTotal: number,
      values: AccessorialFormType | BaseFreightFormType
    ) => void
  }
}
